import React from "react";

const News = () => {
  return (
    <div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="img-responsive">
              <img
                style={{ width: "400px", height: "400px", padding: "40px" }}
                src={"/assets/news/image1.jpg"}
                alt="image1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
